var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99992 2.66669C2.52716 2.66669 1.33325 3.86059 1.33325 5.33335V11.3334C1.33325 12.4379 2.22868 13.3334 3.33325 13.3334H9.33325H9.99992H10.6666H12.6666C13.7712 13.3334 14.6666 12.4379 14.6666 11.3334V8.66669C14.6666 7.19393 13.4727 6.00002 11.9999 6.00002H10.6666V5.33335C10.6666 3.86059 9.47268 2.66669 7.99992 2.66669H3.99992ZM10.6666 7.33335V12H12.6666C13.0348 12 13.3333 11.7015 13.3333 11.3334V8.66669C13.3333 7.93031 12.7363 7.33335 11.9999 7.33335H10.6666ZM9.33325 6.00002V5.33335C9.33325 4.59697 8.7363 4.00002 7.99992 4.00002H3.99992C3.26354 4.00002 2.66659 4.59697 2.66659 5.33335V11.3334C2.66659 11.7015 2.96506 12 3.33325 12H9.33325V6.66669V6.00002Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 11.3334C4.66675 10.9652 4.96523 10.6667 5.33342 10.6667H6.66675C7.03494 10.6667 7.33342 10.9652 7.33342 11.3334V13.3333H4.66675V11.3334Z",
    fill: "#FF865C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.33331C5.63181 5.33331 5.33333 5.63179 5.33333 5.99998V6.66665H4.66667C4.29848 6.66665 4 6.96512 4 7.33331C4 7.7015 4.29848 7.99998 4.66667 7.99998H5.33333V8.66665C5.33333 9.03483 5.63181 9.33331 6 9.33331C6.36819 9.33331 6.66667 9.03483 6.66667 8.66665V7.99998H7.33333C7.70152 7.99998 8 7.7015 8 7.33331C8 6.96512 7.70152 6.66665 7.33333 6.66665L6.66667 6.66665V5.99998C6.66667 5.63179 6.36819 5.33331 6 5.33331Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.dbb64392b6aec85fb118054b64f64ba1.svg";
export { ForwardRef as ReactComponent };